export default "__VITE_ASSET__CGgVLBtd__"